import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { SystemRoleDialogComponent } from '../../Dialogs/system-role-dialog/system-role-dialog.component';
import { AvEmptyStateComponent } from '../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { AvStatusChipComponent } from '../../../../Shared/Components/av-status-chip/av-status-chip.component';
import { TeamFacade } from '../../../../../Facades/Users/team.facade';
import { DATE_FORMAT, VALUE_UNRESOLVED } from '../../../../../Consts/backoffice.const';
import { SystemRoleDialogResult } from '../../../Interfaces/system-role-dialog.interface';
import { SystemUser } from '../../../../../Models/backoffice/system-user.model';

@Component({
  selector: 'app-team',
  standalone: true,
  imports: [
    DatePipe,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    AvEmptyStateComponent,
    AvStatusChipComponent,
  ],
  templateUrl: './team.component.html',
  styleUrl: './team.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class TeamComponent {
  private readonly _dialog = inject(MatDialog);

  readonly facade = inject(TeamFacade);

  readonly dateFormat = DATE_FORMAT;
  readonly unresolved = VALUE_UNRESOLVED;

  openRoleDialog(operator: SystemUser): void {
    const reference = this._dialog.open(SystemRoleDialogComponent, {
      data: {
        userName: operator.fullName,
        userEmail: operator.email ?? this.unresolved,
        currentRole: operator.systemRole,
        isSelf: operator.id === this.facade.currentOperatorId(),
        adminCount: this.facade.adminCount(),
      },
    });

    reference
      .afterClosed()
      .subscribe((result?: SystemRoleDialogResult) => this._applyRole(operator, result));
  }

  private _applyRole(operator: SystemUser, result?: SystemRoleDialogResult): void {
    if (!result) {
      return;
    }

    this.facade.updateSystemRole(operator.id, result.systemRole, result.force);
  }
}
